/**
 * @generated SignedSource<<457a9625d38894e77ba421de02e5b990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fontSize"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fontSize",
        "variableName": "fontSize"
      },
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      },
      {
        "kind": "Variable",
        "name": "unit",
        "variableName": "unit"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateDefaultFont",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDefaultFontMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateDefaultFontMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "789289b4779bfb22492e4d8f995851b9",
    "id": null,
    "metadata": {},
    "name": "UpdateDefaultFontMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDefaultFontMutation(\n  $teamId: ID!\n  $value: String!\n  $fontSize: Int!\n  $unit: String!\n) {\n  updateDefaultFont(teamId: $teamId, value: $value, fontSize: $fontSize, unit: $unit) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "61520317eb29e4a3c6669599f713e8c5";

export default node;
